export default __webpack_public_path__ + "static/media/alcoholic-drink.265bcfbf.svg";